//
// These are the lists associated with the roles available in the system for PVSIS.
// If any action (update, delete, insert) is performed in system, should be performed on all these lists of roles
//

export const roles = {
    1: 'dataMigrator',
    2: 'superAdministrator',
    3: 'businessAdmin',
    4: 'itAdmin',
    5: 'cbdStaff',
    6: 'dsdStaff',
    7: 'arvpStaff',
    8: 'radStaff',
    9: 'otherStaff',
    10: 'woahDirection',
    11: 'comex',
    12: 'headRrSrr',
    13: 'staffRrSrr',
    14: 'delegates',
    15: 'focalPoints',
    16: 'pnDG',
    17: 'pnDR',
    18: 'dtis',
    19: 'did',
    20: 'docCell',
    21: 'experts',
    22: 'prd',
    23: 'eventCoordU',
    24: 'genServU',
    25: 'budgetU',
    26: 'scienceDep',
    27: 'accountingU',
    28: 'commDep',
    29: 'publicationU',
    30: 'pcmU',
    31: 'hr',
    32: 'legalAffairU',
    33: 'eid',
    34: 'standardsDep',
    35: 'wahiad',
    36: 'externalStaff',
    37: 'otherNationalOfficials',
    38: 'specialistCommissions',
    39: 'woahReferenceCentres',
    40: 'woahAdHocGroups',
    41: 'woahWorkingGroups',
    42: 'institutionalPartners',
    43: 'resourcePartnersDonors',
    44: 'delegateProxy',
    45: 'missionContactPerson'
};

export const roleWithIds = {
    dataMigrator: 1,
    superAdministrator: 2,
    businessAdmin: 3,
    itAdmin: 4,
    cbdStaff: 5,
    dsdStaff: 6,
    arvpStaff: 7,
    radStaff: 8,
    otherStaff: 9,
    woahDirection: 10,
    comex: 11,
    headRrSrr: 12,
    staffRrSrr: 13,
    delegates: 14,
    focalPoints: 15,
    pnDG: 16,
    pnDR: 17,
    dtis: 18,
    did: 19,
    docCell: 20,
    experts: 21,
    prd: 22,
    eventCoordU: 23,
    genServU: 24,
    budgetU: 25,
    scienceDep: 26,
    accountingU: 27,
    commDep: 28,
    publicationU: 29,
    pcmU: 30,
    hr: 31,
    legalAffairU: 32,
    eid: 33,
    standardsDep: 34,
    wahiad: 35,
    externalStaff: 36,
    otherNationalOfficials: 37,
    specialistCommissions: 38,
    woahReferenceCentres: 39,
    woahAdHocGroups: 40,
    woahWorkingGroups: 41,
    institutionalPartners: 42,
    resourcePartnersDonors: 43,
    delegateProxy: 44,
    missionContactPerson: 45
};


export const allowedRoles = {
    dataMigrator: false,
    superAdministrator: false,
    businessAdmin: false,
    itAdmin: false,
    cbdStaff: false,
    dsdStaff: false,
    arvpStaff: false,
    radStaff: false,
    otherStaff: false,
    woahDirection: false,
    comex: false,
    headRrSrr: false,
    staffRrSrr: false,
    delegates: false,
    focalPoints: false,
    pnDG: false,
    pnDR: false,
    dtis: false,
    did: false,
    docCell: false,
    experts: false,
    prd: false,
    eventCoordU: false,
    genServU: false,
    budgetU: false,
    scienceDep: false,
    accountingU: false,
    commDep: false,
    publicationU: false,
    pcmU: false,
    hr: false,
    legalAffairU: false,
    eid: false,
    standardsDep: false,
    wahiad: false,
    externalStaff: false,
    otherNationalOfficials: false,
    specialistCommissions: false,
    woahReferenceCentres: false,
    woahAdHocGroups: false,
    woahWorkingGroups: false,
    institutionalPartners: false,
    resourcePartnersDonors: false,
    delegateProxy: false,
    missionContactPerson: false
};

